"use client";

// The centred card + FRONTLINE wordmark used by the public auth screens
// (forgot / reset password). Same look as /login; useTheme() falls back to dark
// when no ThemeProvider is mounted.

import type { ReactNode } from "react";
import { useTheme } from "@/lib/platform/theme/ThemeContext";

export function useAuthStyles() {
  const { tokens, fonts } = useTheme();
  return {
    tokens,
    fonts,
    input: {
      width: "100%",
      background: tokens.bg,
      border: `1px solid ${tokens.rule2}`,
      borderRadius: 8,
      color: tokens.ink,
      fontFamily: fonts.sans,
      fontSize: 15,
      padding: "11px 12px",
      marginTop: 6,
    },
    label: {
      fontFamily: fonts.mono,
      fontSize: 11,
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      color: tokens.dim,
    },
    primary: (pending: boolean) => ({
      width: "100%",
      background: tokens.clay,
      color: tokens.onClay,
      border: "none",
      borderRadius: 999,
      fontFamily: fonts.sans,
      fontSize: 15,
      fontWeight: 600,
      padding: "12px 0",
      cursor: pending ? "default" : "pointer",
      opacity: pending ? 0.7 : 1,
    }),
    message: (tone: "error" | "info") => ({
      fontFamily: fonts.sans,
      fontSize: 13,
      color: tone === "error" ? tokens.clay : tokens.dim,
      marginBottom: 14,
      lineHeight: 1.4,
    }),
    link: {
      display: "block",
      textAlign: "center",
      color: tokens.dim,
      fontFamily: fonts.mono,
      fontSize: 11,
      letterSpacing: "0.04em",
      marginTop: 16,
      textDecoration: "none",
    },
  } as const;
}

export function AuthCard({ children }: { children: ReactNode }) {
  const { tokens, fonts } = useTheme();
  return (
    <div
      style={{
        minHeight: "100dvh",
        background: tokens.pageBg,
        color: tokens.ink,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 20,
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 360,
          background: tokens.bg2,
          border: `1px solid ${tokens.rule}`,
          borderRadius: 16,
          padding: "26px 22px",
        }}
      >
        <div
          style={{
            fontFamily: fonts.mono,
            fontSize: 13,
            letterSpacing: "0.14em",
            color: tokens.ink,
            borderBottom: `1px solid ${tokens.clay}`,
            display: "inline-block",
            paddingBottom: 2,
            marginBottom: 20,
          }}
        >
          FRONTLINE
        </div>
        {children}
      </div>
    </div>
  );
}
